// js
import React from 'react';
import PropTypes from 'prop-types';


const ReleaseNotes = ({ items }) => (

  <div className='release-notes'>
    {items.map((item, itemIndex) => {
      const [title, subItems] = item;
      return (
        <div key={itemIndex} className='release-notes-item'>
          <h3>{title}</h3>
          <ul>
            {subItems.map((subItem, subItemIndex) => {
              if (typeof(subItem) === 'string') {
                return (
                  <li key={subItemIndex} className='release-notes-sub-item'>
                    {subItem}
                  </li>
                );
              }
              const [title, subSubItems] = subItem;
              return (
                <li key={subItemIndex} className='release-notes-sub-item'>
                  {title}
                  <ul>
                    {subSubItems.map((subSubItem, subSubItemIndex) => (
                      <li key={subSubItemIndex}>{subSubItem}</li>
                    ))}
                  </ul>
                </li>
              );
            })}
          </ul>
        </div>
      );
    })}
  </div>
);

ReleaseNotes.propTypes = {
  items: PropTypes.array.isRequired
};

export default ReleaseNotes;



// WEBPACK FOOTER //
// ./src/components/ReleaseNotes.js